"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
var TENANT_TEMPLATE_PARAMETER = '{tenant}';
var UploadsUrlBuilder = /*#__PURE__*/
function () {
  function UploadsUrlBuilder(_ref) {
    var imageUploadUrl = _ref.imageUploadUrl,
      fileUploadUrl = _ref.fileUploadUrl,
      pdfUploadUrl = _ref.pdfUploadUrl,
      archiveUploadUrl = _ref.archiveUploadUrl,
      tenant = _ref.tenant;
    _classCallCheck(this, UploadsUrlBuilder);
    this.imageUploadUrl = imageUploadUrl;
    this.fileUploadUrl = fileUploadUrl;
    this.pdfUploadUrl = pdfUploadUrl;
    this.archiveUploadUrl = archiveUploadUrl;
    this.tenant = tenant;
  }
  _createClass(UploadsUrlBuilder, [{
    key: "getImageUploadUrl",
    value: function getImageUploadUrl() {
      return this.imageUploadUrl.replace(TENANT_TEMPLATE_PARAMETER, this.tenant);
    }
  }, {
    key: "getFileUploadUrl",
    value: function getFileUploadUrl() {
      return this.fileUploadUrl.replace(TENANT_TEMPLATE_PARAMETER, this.tenant);
    }
  }, {
    key: "getPdfUploadUrl",
    value: function getPdfUploadUrl() {
      return this.pdfUploadUrl.replace(TENANT_TEMPLATE_PARAMETER, this.tenant);
    }
  }, {
    key: "getArchiveGenerationUrl",
    value: function getArchiveGenerationUrl() {
      return this.archiveUploadUrl.replace(TENANT_TEMPLATE_PARAMETER, this.tenant);
    }
  }]);
  return UploadsUrlBuilder;
}();
var _default = UploadsUrlBuilder;
exports["default"] = _default;